export const getTranslate = (kk, ru, lang = 'kk') => {
  return lang === 'kk' ? kk : ru;
};
